import { useState, useEffect } from 'react';
import { cn } from '@/shared/lib/cn';

interface NumberInputProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  placeholder?: string;
  className?: string;
  integer?: boolean;
}

export function NumberInput({ value, onChange, min, max, placeholder, className, integer = false }: NumberInputProps) {
  const [local, setLocal] = useState(String(value));

  useEffect(() => {
    setLocal(String(value));
  }, [value]);

  const commit = (raw: string) => {
    if (raw === '' || raw === '-') return;
    const num = integer ? parseInt(raw, 10) : parseFloat(raw);
    if (isNaN(num)) return;
    const clamped =
      min !== undefined && max !== undefined
        ? Math.min(max, Math.max(min, num))
        : min !== undefined
          ? Math.max(min, num)
          : max !== undefined
            ? Math.min(max, num)
            : num;
    onChange(clamped);
    setLocal(String(clamped));
  };

  return (
    <input
      type="text"
      inputMode={integer ? 'numeric' : 'decimal'}
      className={cn(
        'bg-white/55 border border-white/60 rounded-[14px] outline-none',
        'focus:border-brand-green transition-colors',
        className,
      )}
      placeholder={placeholder}
      value={local}
      onChange={(e) => {
        const raw = integer
          ? e.target.value.replace(/[^0-9]/g, '')
          : e.target.value.replace(/[^0-9.]/g, '');
        setLocal(raw);
        if (raw !== '') commit(raw);
      }}
      onBlur={() => commit(local)}
    />
  );
}
